var map = {
	"./Bear New Year.webp": 5371,
	"./Diamond Ring.webp": 5016,
	"./Kissed Frog.webp": 4249,
	"./Plush Pepe.webp": 3110,
	"./Snoop Dogg.webp": 1930,
	"./Statue of Liberty.webp": 6724,
	"./Swiss Watch.webp": 7094,
	"./Toy Bear.webp": 7176
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6799;